export default "__VITE_ASSET__BGwO28bj__"